import script from "./SettingsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SettingsButton.vue?vue&type=script&setup=true&lang=ts"

import "./SettingsButton.vue?vue&type=style&index=0&id=30398a94&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30398a94"]])

export default __exports__